import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SubstituteProductionLotCatalogMutationVariables = Types.Exact<{
  input: Types.SubstituteProductionLotCatalogInput;
}>;


export type SubstituteProductionLotCatalogMutation = { __typename?: 'Mutation', substituteProductionLotCatalog: { __typename?: 'ProductionLotSubstitutionPayload', lots: Array<{ __typename?: 'ProductionLotSubstitutionLot', productionLotId: string, scope: Types.ProductionLotSubstitutionScope, substituted: boolean, hasPlannerOverrides: boolean, isLotSiteVariation: boolean, productionItemIdBefore?: string | null, productionItemIdAfter?: string | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, missingRecipes: Array<{ __typename?: 'ProductionLotSubstitutionMissingRecipe', productionCategoryId: string, productionCategoryName: string, sourceProductionRecipeId: string }>, blockingAllocations: Array<{ __typename?: 'ProductionLotSubstitutionAllocation', allocationId: string, orderId: string, orderLineId?: string | null }>, jobs: Array<{ __typename?: 'ProductionLotSubstitutionJob', productionJobId: string, productionCategoryId: string, previousProductionRecipeId: string, newProductionRecipeId?: string | null, weekReadyDate: Types.TDateISO, weekStartDateBefore: Types.TDateISO, weekStartDateAfter?: Types.TDateISO | null, quantityToProduceAfter?: number | null }> }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SubstituteProductionLotCatalogDocument = new TypedDocumentString(`
    mutation SubstituteProductionLotCatalog($input: SubstituteProductionLotCatalogInput!) {
  substituteProductionLotCatalog(input: $input) {
    lots {
      ...ProductionLotSubstitutionLotData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotSubstitutionLotData on ProductionLotSubstitutionLot {
  productionLotId
  scope
  substituted
  errors {
    code
    message
  }
  missingRecipes {
    productionCategoryId
    productionCategoryName
    sourceProductionRecipeId
  }
  blockingAllocations {
    allocationId
    orderId
    orderLineId
  }
  hasPlannerOverrides
  isLotSiteVariation
  productionItemIdBefore
  productionItemIdAfter
  jobs {
    productionJobId
    productionCategoryId
    previousProductionRecipeId
    newProductionRecipeId
    weekReadyDate
    weekStartDateBefore
    weekStartDateAfter
    quantityToProduceAfter
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SubstituteProductionLotCatalog: build.mutation<SubstituteProductionLotCatalogMutation, SubstituteProductionLotCatalogMutationVariables>({
      query: (variables) => ({ document: SubstituteProductionLotCatalogDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSubstituteProductionLotCatalogMutation } = injectedRtkApi;
